var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"amui-modal"},[_c('div',{staticClass:"amui-modal__overlay",on:{"click":_vm.close}}),_c('div',{staticClass:"amui-modal__content"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }